/**
 * @generated SignedSource<<eba98b1582841a49ed6eff648e20fc51>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type OrganizationRole = "ADMIN" | "MEMBER" | "OWNER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InvitationPageFragment$data = {
  readonly email: string;
  readonly id: string;
  readonly inviterName: string;
  readonly organizationName: string;
  readonly role: OrganizationRole;
  readonly " $fragmentType": "InvitationPageFragment";
};
export type InvitationPageFragment$key = {
  readonly " $data"?: InvitationPageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"InvitationPageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvitationPageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inviterName",
      "storageKey": null
    }
  ],
  "type": "Invitation",
  "abstractKey": null
};

(node as any).hash = "dd0b0af773513af877ab4e3f0b51d837";

export default node;
